<app-guide-card
  [fullWidth]="fullWidth"
  [valid]="form.get(formGroupName)?.valid"
>
  <div title>{{ (overrideTitle ?? 'meteringPoint.create.address.title') | translate }}</div>
  <div description>{{ 'meteringPoint.create.address.description' | translate }}</div>
  <div>

    <div class="flex flex-col">
      <div class="w-full">

        <form [formGroup]="form">
          <fieldset [formGroupName]="formGroupName">
            <div class="flex pb-4">
              <a
                href="#"
                class="w-1/2 text-center border-l border-t border-b border-gray-200 rounded-l-md border-r-none px-4 py-2 text-gray-400 text-sm font-normal hover:bg-gray-50"
                [ngClass]="advancedInput ? null : 'bg-theme-primary border-theme-primary text-white hover:bg-theme-primary'"
                (click)="$event.preventDefault(); activateSearch()"
              >{{ 'common.searching' | translate }}</a>
              <a
                class="w-1/2 text-center border border-gray-200 rounded-r-md border-l-none px-4 py-2 text-gray-400 text-sm font-normal hover:bg-gray-50"
                [ngClass]="advancedInput ? 'bg-theme-primary border-theme-primary text-white hover:bg-theme-primary' : null"
                (click)="$event.preventDefault(); activateAdvanced()"
                href="#">{{ 'common.advanced' | translate }}</a>
            </div>
          </fieldset>
        </form>
        <div class="w-full">
          <app-input-group>
            <label appLabel>{{ 'address.addressType' | translate }}</label>
            <select appSelect [collection]="addressTypeList" [(ngModel)]="addressType" (ngModelChange)="search.clearInput()"></select>
          </app-input-group>

          <app-input-group>
            <label appLabel>{{ 'address.daraddress' | translate }}</label>
            <app-input-search
              #search
              [config]="searchConfig"
              (result)="addressSelected($event)">
            </app-input-search>
          </app-input-group>
        </div>
      </div>

      <form [formGroup]="form">
        <fieldset [formGroupName]="formGroupName">
          <div class="w-full">
            <div class="h-[1px] bg-gray-200 dark:bg-dark-border mt-6 mb-4"></div>

            <app-input-group>
              <label appLabel>{{ 'address.roadcode' | translate }}</label>
              <input appInput formControlName="streetCode">
            </app-input-group>

            <app-input-group>
              <label appLabel>{{ 'address.streetName' | translate }}</label>
              <input appInput formControlName="streetName">
            </app-input-group>

            <app-input-group>
              <label appLabel>{{ 'address.streetNumber' | translate }}</label>
              <input appInput formControlName="buildingNumber">
            </app-input-group>

            <app-input-group>
              <label appLabel>{{ 'address.floor' | translate }}</label>
              <input appInput formControlName="floorIdentification">
            </app-input-group>

            <app-input-group>
              <label appLabel>{{ 'address.door' | translate }}</label>
              <input appInput formControlName="roomIdentification">
            </app-input-group>

            <app-input-group>
              <label appLabel>{{ 'address.zipCode' | translate }}</label>
              <input appInput formControlName="postalCode">
            </app-input-group>

            <app-input-group>
              <label appLabel>{{ 'address.city' | translate }}</label>
              <input appInput formControlName="cityName">
            </app-input-group>
          </div>

          <div class="w-full">
            <app-input-group>
              <label appLabel>{{ 'address.postaldistrict' | translate }}</label>
              <input appInput formControlName="subDivisionName">
            </app-input-group>

            <app-input-group>
              <label appLabel>{{ 'address.municipalcode' | translate }}</label>
              <input appInput formControlName="municipalityCode">
            </app-input-group>

            <app-input-group>
              <label appLabel>{{ 'address.countrycode' | translate }}</label>
              <input appInput formControlName="country">
            </app-input-group>

            @if (this.advancedInput) {
              <a class="text-gray-400 underline text-sm font-normal" href="#"
                 (click)="$event.preventDefault();sanitizeAddress()">{{ 'address.cleanAddress' | translate }}</a>
            }
          </div>
        </fieldset>
      </form>
      @if (this.form.get('detailCharacteristics.locationDescription')) {
        <div [formGroup]="form" class="mt-6">
          <div formGroupName="detailCharacteristics">
            <app-input-group>
              <label appLabel>{{ 'meter.createform.comments' | translate }}</label>
              <input appInput formControlName="locationDescription">
            </app-input-group>
          </div>
        </div>
      }
    </div>

  </div>
</app-guide-card>
